import { HeroSection as HeroSectionNew } from "@/components/ui/hero-section-2";

export function HeroSection() {
  return (
    <HeroSectionNew
      logo={{
        url: "/favicon.ico",
        alt: "SOL-VI Logo",
        text: "SOL-VI"
      }}
      slogan="DUURZAME ENERGIE OPLOSSINGEN"
      title={
        <>
          Energieneutraal <br />
          <span className="text-primary">Wonen Begint Hier</span>
        </>
      }
      subtitle="Specialist in zonnepanelen, warmtepompen en thuisbatterijen in Elst en regio Gelderland. Van advies tot installatie, alles onder één dak."
      callToAction={{
        text: "GRATIS ENERGIEADVIES",
        href: "/offerte",
      }}
      backgroundImage="/lovable-uploads/2e059043-9966-495c-aafa-11e787ef2d12.png"
      contactInfo={{
        website: "sol-vi.nl",
        phone: "+31 6 17105786",
        address: "Elst, Gelderland",
      }}
    />
  );
}